"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NOW_LOADING_FULFILLMENT_CONFIGURATIONS: 'NOW_LOADING_FULFILLMENT_CONFIGURATIONS',
  RECEIVED_FULFILLMENT_CONFIGURATIONS: 'RECEIVED_FULFILLMENT_CONFIGURATIONS',
  DONE_LOADING_FULFILLMENT_CONFIGURATIONS: 'DONE_LOADING_FULFILLMENT_CONFIGURATIONS',
  SELECTING_FULFILLMENT_CONFIGURATION: 'SELECTING_FULFILLMENT_CONFIGURATION',
  CLEARING_SELECTED_FULFILLMENT_CONFIGURATION: 'CLEARING_SELECTED_FULFILLMENT_CONFIGURATION',
  ERROR_LOADING_FULFILLMENT_CONFIGURATION: 'ERROR_LOADING_FULFILLMENT_CONFIGURATION'
};
exports["default"] = _default;